import React from "react"
import PropTypes from "prop-types"

import scrollObserverHOC from "shared/components/scroll_observer_hoc"

class WrappedScrollObserver extends React.Component {
  componentDidMount() {
    this.scrollObserverEl = this.props.scrollRef.current
  }

  handleScrolledIntoView = () => {
    this.props.onScrolledIntoView()
  }

  render() {
    return this.props.children
  }
}

WrappedScrollObserver.propTypes = {
  onScrolledIntoView: PropTypes.func.isRequired,
  scrollRef: PropTypes.object,
  children: PropTypes.node.isRequired,
}

const ScrollObserver = scrollObserverHOC(WrappedScrollObserver)

export default ScrollObserver
